import EmailBasedAuth from '../EmailBasedAuth/EmailBasedAuth';

class AuthModal extends EmailBasedAuth {
    constructor(props) {
        super(props, props.device.logo_url, props.device.id);
    }
}

export default AuthModal;
